(() => {
  const root = document.querySelector('[data-lllc]');
  if (!root) return;
  const grid = root.querySelector('[data-lllc-grid]');
  const bar = root.querySelector('[data-lllc-bar]');
  const q = root.querySelector('[data-lllc-q]');
  const sortSel = root.querySelector('[data-lllc-sort]');
  const countEl = root.querySelector('[data-lllc-count]');
  const empty = root.querySelector('[data-lllc-empty]');
  const priceGrp = root.querySelector('[data-lllc-g="price"]');
  const sec = root.closest('.shopify-section');
  const sectionId = sec ? sec.id.replace('shopify-section-', '') : '';
  const pages = +grid.dataset.pages || 1;
  const state = { type: '', power: '', price: '', q: '', sort: sortSel ? sortSel.value : '' };
  let items = [];
  let buckets = [];

  const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  const fmt = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur, maximumFractionDigits: 0 });
  const nice = v => { const s = v >= 200 ? 50 : 10; return Math.max(s, Math.round(v / s) * s); };

  async function loadAll() {
    for (let p = 2; p <= pages; p++) {
      try {
        const url = new URL(location.href);
        url.searchParams.set('page', p);
        url.searchParams.set('section_id', sectionId);
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-lllc-grid] > .lllc__item').forEach(el => grid.appendChild(document.adoptNode(el)));
      } catch (e) { break; }
    }
  }

  function setupGroups() {
    const kinds = new Set(items.map(i => i.dataset.k));
    if (kinds.size < 2) root.querySelector('[data-lllc-g="type"]').innerHTML = '';
    const pw = items.map(i => i.dataset.w);
    if (!pw.some(w => w.includes('usb')) || !pw.some(w => w.includes('12v'))) root.querySelector('[data-lllc-g="power"]').innerHTML = '';
    const prices = items.map(i => +i.dataset.p / 100).sort((a, b) => a - b);
    if (prices.length >= 6 && prices[prices.length - 1] > prices[0] * 1.5) {
      let a = nice(prices[Math.floor(prices.length / 3)]), b = nice(prices[Math.floor(prices.length * 2 / 3)]);
      if (b <= a) b = a + (a >= 200 ? 50 : 10);
      buckets = [[0, a], [a, b], [b, Infinity]];
      const lbl = ['< ' + fmt.format(a), fmt.format(a) + ' – ' + fmt.format(b), '> ' + fmt.format(b)];
      priceGrp.innerHTML = buckets.map((_, i) => `<button type="button" data-v="${i}">${lbl[i]}</button>`).join('');
    }
  }

  function readUrl() {
    const sp = new URLSearchParams(location.search);
    ['type', 'power', 'price', 'q', 'sort'].forEach(k => { if (sp.get(k) !== null) state[k] = sp.get(k); });
    if (q) q.value = state.q;
    if (sortSel && state.sort) sortSel.value = state.sort;
  }

  function writeUrl() {
    const url = new URL(location.href);
    ['type', 'power', 'price', 'q', 'sort'].forEach(k => {
      const v = k === 'sort' && state.sort === grid.dataset.default ? '' : state[k];
      v ? url.searchParams.set(k, v) : url.searchParams.delete(k);
    });
    url.searchParams.delete('page');
    history.replaceState(null, '', url);
  }

  function apply() {
    const words = state.q.toLowerCase().split(/\s+/).filter(Boolean);
    let n = 0;
    items.forEach(it => {
      const p = +it.dataset.p / 100;
      const ok = (!state.type || it.dataset.k === state.type)
        && (!state.power || it.dataset.w.includes(state.power))
        && (state.price === '' || !buckets[state.price] || (p >= buckets[state.price][0] && p < buckets[state.price][1]))
        && words.every(w => it.dataset.t.includes(w));
      it.hidden = !ok;
      if (ok) n++;
    });
    const s = state.sort;
    const key = {
      'price-ascending': (a, b) => a.dataset.p - b.dataset.p,
      'price-descending': (a, b) => b.dataset.p - a.dataset.p,
      'title-ascending': (a, b) => a.dataset.t.localeCompare(b.dataset.t),
      'created-descending': (a, b) => b.dataset.c - a.dataset.c
    }[s] || ((a, b) => a.dataset.i - b.dataset.i);
    [...items].sort(key).forEach(it => grid.appendChild(it));
    countEl.textContent = n + ' Designs';
    empty.hidden = n > 0;
    root.querySelectorAll('[data-lllc-g] button').forEach(b => {
      b.setAttribute('aria-pressed', state[b.parentElement.dataset.lllcG] === b.dataset.v);
    });
    writeUrl();
  }

  async function init() {
    await loadAll();
    items = [...grid.querySelectorAll('.lllc__item')];
    items.forEach((it, i) => { it.dataset.i = i; });
    setupGroups();
    readUrl();
    bar.hidden = false;
    root.querySelectorAll('[data-lllc-g]').forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b) return;
      const k = g.dataset.lllcG;
      state[k] = state[k] === b.dataset.v ? '' : b.dataset.v;
      apply();
    }));
    let t;
    q && q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => { state.q = q.value.trim(); apply(); }, 150); });
    sortSel && sortSel.addEventListener('change', () => { state.sort = sortSel.value; apply(); });
    root.querySelector('[data-lllc-reset]').addEventListener('click', () => {
      Object.assign(state, { type: '', power: '', price: '', q: '' });
      if (q) q.value = '';
      apply();
    });
    apply();
    bar.style.transition = 'opacity .2s, transform .2s';
    const past = () => {
      const off = grid.getBoundingClientRect().bottom < bar.offsetHeight + 60;
      bar.style.opacity = off ? '0' : '';
      bar.style.pointerEvents = off ? 'none' : '';
      bar.style.transform = off ? 'translateY(-8px)' : '';
    };
    addEventListener('scroll', past, { passive: true });
    past();
  }
  init();
})();
